import Highcharts from 'highcharts';

export const figure26 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        marginLeft: 250,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '1000px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#ed7d31', '#5b9bd5'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },

      plotOptions: {
        bar: {
          dataLabels: {
              enabled: true
          }
      }
    },
  
      exporting: {
        enabled: false
      },

      xAxis: [{
        categories: [ 
          "Afganistán 2015",
          "Albania 2017",
          "Armenia 2015",
          "Benin 2018",
          "Botswana 2019",
          "Burkina Faso 2014",
          "Burundi 2016",
          "Camboya 2014",
          "Camerún 2018",
          "Chad 2014",
          "Côte d’Ivoire 2018",
          "Etiopía 2016",
          "Guatemala 2014",
          "Guinea-Bissau 2018",
          "Haití 2016",
          "India 2015",
          "Indonesia 2017",
          "Lesotho 2014",
          "Malawi 2017",
          "Malí 2018",
          "Myanmar 2015",
          "Nepal 2016",
          "Níger 2018",
          "Nigeria 2019",
          "Perú 2018",
          "Rwanda 2014",
          "Senegal 2018",
          "Sierra Leona 2019",
          "República Unida de Tanzanía 2016",
          "Togo 2018",
          "Uganda 2019",
          "Zambia 2018",
          "Zimbabwe 2015",
         ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{
        labels: {
          format: '{value}',
          formatter: function () {
            return this.value + '.00';
        },
        style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 80,
        min: 0,
        tickInterval: 10,
        gridLineWidth: 2,
        title: {
          text: null,
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [{
        name: 'Mujeres',
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [ 45.2, 44.9, 40.2, 10.5, 48.9, 44.6, 6.5, 60, 8, 26.4, 9.4, 13.3, 56.7, 42.4, 51.2, 32.7, 42.8, 5.8, 35.1, 10.8, 19.9, 53.6, 11.1, 43.6, 20.5, 65.2, 65.7, 5.9, 55.4, 18.4, 34, 29.9, 31.4 ].reverse(),
      },
      {
        name: 'Hombres',
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [ 49.2, 56.6, 61.5, 43.1, 60.8, 53.8, 35.5, 66, 18.6, 62.2, 66, 28, 56.9, 59.8, 44.7, 32.4, 61.2, 63, 49.9, 41, 39.1, 66.2, 63.4, 73.4, 52.4, 60.7, 68.8, 35, 47.1, 54.8, 65.9, 53.4, 70.5 ].reverse()
      }
    ]
}